"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadonlyCollectionViewCtrl = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
/**
 * A minimal readonly controller stub that implements the interface needed by
 * CollectionEditViewSubform and CollectionEditViewField for readonly rendering.
 *
 * Key behaviors:
 * - isEditing = false: Uses viewInline() instead of viewEdit()
 * - canInspectCollection() returns false: Disables clickable links on vector fields
 * - All edit operations are no-ops
 */
class ReadonlyCollectionViewCtrl {
    constructor() {
        this.kind = 'ReadonlyCollectionViewCtrl';
        /** Always false - renders fields in readonly mode */
        this.isEditing = false;
        /** Enable color coding for span colors */
        this.useColorCoding = true;
        /** Field detail visibility state */
        this.isFieldDetailShown = mobx_1.observable.map({}, { deep: false });
        /** No change state in readonly mode */
        this.changeState = null;
        /** Not uploading in readonly mode */
        this.isUploading = false;
        this.fieldsInLoadingState = [];
        /** Not saving in readonly mode */
        this.isSaving = false;
        /** Expansion state for subform instances */
        this.isFormOpen = mobx_1.observable.map({}, { deep: false });
        /** Default to expanded for preview */
        this.isAllExpanded = true;
    }
    static is(ctrl) {
        return ctrl.kind === 'ReadonlyCollectionViewCtrl';
    }
    /**
     * Check if a subform instance is expanded.
     * Always returns true for preview mode (all expanded).
     */
    isExpanded(instanceId) {
        var _a;
        if (this.isAllExpanded) {
            return this.isFormOpen.get(instanceId) !== false;
        }
        return (_a = this.isFormOpen.get(instanceId)) !== null && _a !== void 0 ? _a : false;
    }
    /**
     * Toggle expansion state for a subform instance.
     */
    toggleExpanded(e, instanceId) {
        e.preventDefault();
        let prev = this.isFormOpen.get(instanceId);
        if (prev == null) {
            prev = this.isAllExpanded;
        }
        this.isFormOpen.set(instanceId, !prev);
        return false;
    }
    /**
     * Toggle field detail visibility.
     */
    toggleFieldDetail(fieldId) {
        if (this.isFieldDetailShown.get(fieldId)) {
            this.isFieldDetailShown.delete(fieldId);
        }
        else {
            this.isFieldDetailShown.set(fieldId, true);
        }
    }
    /**
     * Always returns false - disables collection link navigation.
     * This prevents vector fields from rendering as clickable anchors.
     */
    canInspectCollection(_summary) {
        return false;
    }
    /**
     * No-op for readonly mode - inspection is disabled.
     */
    inspectCollection(_revision) {
        // No-op
    }
    /**
     * No-op for readonly mode.
     */
    clearField(_field) {
        // No-op
    }
    /**
     * No-op for readonly mode.
     */
    clearModalField(_field) {
        return Promise.resolve();
    }
    /**
     * No-op for readonly mode.
     */
    beginSpanLink(_collection) {
        // No-op
    }
    /**
     * Always returns true - field has no clear action in readonly mode.
     */
    fillAddressDisabled(_field) {
        return true;
    }
    /**
     * Always returns true - field has no clear action in readonly mode.
     */
    clearErrorDisabled(_field) {
        return true;
    }
    /**
     * No-op for readonly mode.
     */
    fillAddress(_field) {
        return Promise.resolve();
    }
    /**
     * No-op for readonly mode.
     */
    clearError(_field) {
        // No-op
    }
    /**
     * No-op for readonly mode.
     */
    fileDownload(_field) {
        return Promise.resolve(false);
    }
    /**
     * Returns empty string for readonly mode.
     */
    geocodingButtonTitle(_field) {
        return '';
    }
    /**
     * Returns null for field joins in readonly mode.
     */
    getJoin(_field) {
        return null;
    }
    /**
     * Returns null for field joins in readonly mode.
     */
    getOppositeJoin(_field) {
        return null;
    }
    /**
     * No-op for readonly mode.
     */
    onImage(_e, _field) {
        // No-op
    }
    /**
     * No-op for readonly mode.
     */
    openImageDialog(_e, _field) {
        // No-op
    }
    /**
     * No-op for readonly mode.
     */
    selectAnchorField(_e, _field) {
        // No-op
    }
}
exports.ReadonlyCollectionViewCtrl = ReadonlyCollectionViewCtrl;
tslib_1.__decorate([
    mobx_1.observable
], ReadonlyCollectionViewCtrl.prototype, "isFormOpen", void 0);
tslib_1.__decorate([
    mobx_1.observable
], ReadonlyCollectionViewCtrl.prototype, "isAllExpanded", void 0);
tslib_1.__decorate([
    mobx_1.action
], ReadonlyCollectionViewCtrl.prototype, "toggleExpanded", null);
tslib_1.__decorate([
    mobx_1.action
], ReadonlyCollectionViewCtrl.prototype, "toggleFieldDetail", null);
//# sourceMappingURL=readonly.collection.view.ctrl.js.map